<template>
    <div class="body__form">
        <div class="container__form">
            <table class="fm-enqueteout" :cellpadding="`0`" :cellspacing="`0`">
                <tbody>
                    <tr v-if="HEADER">
                        <td>
                            <div class="text-center mb-5">
                                <div v-html="HEADER"></div>
                            </div>
                        </td>
                    </tr>
                    <template v-if="isPageTypeB">
                        <tr
                            v-if="[PAGE_TYPES._B[0], PAGE_TYPES._B[4]].includes(typePageShow) && dataPreview.setting_lottery.is_prize_before_the_draw"
                        >
                            <td>
                                <FormBPrizeCode
                                    :inforData="dataPreview"
                                    :settingDesign="dataPreview.setting_designs"
                                    :formInit="formSerialInit"
                                    :formConfig="formSerialConfig"
                                    :conditionPageShow="typePageShow"
                                />
                            </td>
                        </tr>
                    </template>
                    <tr v-if="isPageTypeI && PAGE_TYPES._I[2] !== typePageShow">
                        <td
                            :class="`text-${onHandleGetValueTextAlign(dataPreview.setting_designs.table_settings.answer_text_alignment.horizontal)}`"
                            :style="`padding: ${
                                dataPreview.setting_designs.table_settings?.cell_setting.margin?.value
                                    ? `${dataPreview.setting_designs.table_settings?.cell_setting.margin?.value}${dataPreview.setting_designs.table_settings?.cell_setting.margin?.unit?.value}`
                                    : '30px'
                            }`"
                        >
                            <div
                                v-if="PAGE_TYPES._I[0] == typePageShow"
                                v-html="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.extension.content"
                            ></div>
                            <div
                                v-if="PAGE_TYPES._I[1] == typePageShow"
                                v-html="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.extension.content"
                            ></div>
                        </td>
                    </tr>
                    <tr>
                        <template v-if="isPageTypeA">
                            <td v-if="!isPageComplete">
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockSaved">
                                        <CommonOption
                                            :key="`preview-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_RADIO,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT,
                                                    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                                    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
                                                    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                                                ].includes(itemBlock.block_type)
                                            "
                                            :index="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :addressInfor="inforAddress"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :disabled="isRouterView"
                                            @selectProvince="onHandleGetSelectProvince"
                                            :settingRequireLabel="settingRequireLabel"
                                        />
                                        <CommonBlockText
                                            :key="`preview-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
                                                    ALL_BLOCK_TYPE.BLOCK_INPUT,
                                                    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                                                    ALL_BLOCK_TYPE.BLOCK_DATE,
                                                    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                                    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                                                    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                                                    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                                    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                                                ].includes(itemBlock.block_type)
                                            "
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :disabled="isRouterView"
                                            @getAddress="handleGetAddress"
                                            :settingRequireLabel="settingRequireLabel"
                                            :settingConfirmLabel="settingConfirmLabel"
                                        />
                                    </template>
                                </table>
                            </td>
                            <td v-else>
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockComplete">
                                        <CommonBlockText
                                            :key="`preview-${idx}`"
                                            v-if="[ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(itemBlock.block_type)"
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :disabled="isRouterView"
                                            @getAddress="handleGetAddress"
                                        />
                                    </template>
                                </table>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeI">
                            <td v-if="PAGE_TYPES._I[2] !== typePageShow">
                                <table
                                    class="fm-enquete"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <CommonBoxMail
                                        :inforData="dataPreview"
                                        :formInit="initFormPageI"
                                        :formConfig="configFormPageI"
                                        :settingDesign="dataPreview.setting_designs"
                                        :conditionPageShow="typePageShow"
                                        :disabled="isRouterView"
                                        :settingRequireLabel="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_requires"
                                        :settingConfirmLabel="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_confirms"
                                        :isConfirmInputTwice="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.extension.confirm_input_twice"
                                    />
                                </table>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeB">
                            <td
                                v-if="
                                    [
                                        PAGE_TYPES._B[0],
                                        PAGE_TYPES._B[1],
                                        PAGE_TYPES._B[2],
                                        PAGE_TYPES._B[3],
                                        PAGE_TYPES._B[4],
                                        'prize_serial'
                                    ].includes(typePageShow)
                                "
                            >
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockSaved">
                                        <CommonOption
                                            :key="`preview-b0-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_RADIO,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT,
                                                    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                                    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
                                                    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                                                ].includes(itemBlock.block_type)
                                            "
                                            :index="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :addressInfor="inforAddress"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :disabled="isRouterView"
                                            @selectProvince="onHandleGetSelectProvince"
                                            :settingRequireLabel="settingRequireLabelSerialCode"
                                        />
                                        <CommonBlockText
                                            :key="`preview-b0-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
                                                    ALL_BLOCK_TYPE.BLOCK_INPUT,
                                                    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                                                    ALL_BLOCK_TYPE.BLOCK_DATE,
                                                    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                                    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                                                    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                                                    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                                    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                                                ].includes(itemBlock.block_type)
                                            "
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :disabled="isRouterView"
                                            @getAddress="handleGetAddress"
                                            :settingRequireLabel="settingRequireLabelSerialCode"
                                            :settingConfirmLabel="settingConfirmLabelSerialCode"
                                        />
                                    </template>
                                </table>
                            </td>
                        </template>
                    </tr>
                    <tr>
                        <template v-if="isPageTypeA && !isPageType(ID_PAGE_TYPE.C)">
                            <td class="fm-enquete-commands" style="text-align: center">
                                <div class="d-flex justify-content-center mt-5" style="gap: 12px">
                                    <div v-if="typePageShow == PAGE_TYPES._A[0]" class="btn__next" @click="handleSubmit(PAGE_TYPES._A[0])">
                                        <template v-if="settingButtonPreviewInput">
                                            <p v-if="!settingButtonPreviewInput.img_btn_register?.id" class="btn form__btn-secondary text-nowrap">
                                                {{ settingButtonPreviewInput.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreviewInput.img_btn_register?.path"
                                                    :alt="settingButtonPreviewInput.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="btn form__btn-secondary text-nowrap">
                                                {{ $t('managerForm.settingPage.btnSaveForm') }}
                                            </span>
                                        </template>
                                    </div>

                                    <div v-if="isPageConfirm" class="btn__back" @click="handleBackForm">
                                        <template v-if="settingButtonPreview">
                                            <p v-if="!settingButtonPreview.img_btn_back?.id" class="mb-0 btn btn-back-form">
                                                {{ settingButtonPreview.label_btn_back }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreview.img_btn_back?.path"
                                                    :alt="settingButtonPreview.img_btn_back?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p class="mb-0 btn btn-back-form">戻る</p>
                                        </template>
                                    </div>

                                    <div v-if="isPageConfirm" class="btn__confirm" @click="handleSubmit(PAGE_TYPES._A[1])">
                                        <template v-if="settingButtonPreview">
                                            <p v-if="!settingButtonPreview.img_btn_confirm?.id" class="btn form__btn-secondary">
                                                {{ settingButtonPreview.label_btn_confirm }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreview.img_btn_confirm?.path"
                                                    :alt="settingButtonPreview.img_btn_confirm?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p class="btn form__btn-secondary">登録</p>
                                        </template>
                                    </div>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeI">
                            <td v-if="PAGE_TYPES._I[2] !== typePageShow" class="fm-enquete-commands" style="text-align: center">
                                <div class="d-flex justify-content-center mt-5" style="gap: 12px">
                                    <div v-if="typePageShow == PAGE_TYPES._I[0]" class="btn__next" @click="handleSubmit(PAGE_TYPES._I[0])">
                                        <template v-if="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons">
                                            <p
                                                v-if="!onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.img_btn_register?.id"
                                                class="btn form__btn-secondary text-nowrap"
                                            >
                                                {{ onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.img_btn_register?.path"
                                                    :alt="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="btn form__btn-secondary text-nowrap">
                                                {{ $t('managerForm.settingPage.btnSaveForm') }}
                                            </span>
                                        </template>
                                    </div>
                                    <template v-if="PAGE_TYPES._I[1] == typePageShow">
                                        <div class="btn__back" @click="handleBackForm">
                                            <template v-if="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons">
                                                <p
                                                    v-if="!onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_back?.id"
                                                    class="mb-0 btn btn-back-form"
                                                >
                                                    {{ onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.label_btn_back }}
                                                </p>
                                                <div v-else class="btn_frame_img">
                                                    <b-img
                                                        :src="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_back?.path"
                                                        :alt="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_back?.origin_name"
                                                    ></b-img>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="mb-0 btn btn-back-form">戻る</p>
                                            </template>
                                        </div>

                                        <div class="btn__confirm" @click="handleSubmit(PAGE_TYPES._I[1])">
                                            <template v-if="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons">
                                                <p
                                                    v-if="!onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_confirm?.id"
                                                    class="btn form__btn-secondary"
                                                >
                                                    {{ onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.label_btn_confirm }}
                                                </p>
                                                <div v-else class="btn_frame_img">
                                                    <b-img
                                                        :src="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_confirm?.path"
                                                        :alt="
                                                            onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_confirm?.origin_name
                                                        "
                                                    ></b-img>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="btn form__btn-secondary">登録</p>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeB">
                            <td class="fm-enquete-commands" style="text-align: center">
                                <div v-if="typePageShow == PAGE_TYPES._B[0]" class="d-flex justify-content-center mt-5" style="gap: 12px">
                                    <div class="btn__next" @click="handleSubmit(PAGE_TYPES._B[0])">
                                        <template v-if="settingButtonPageBInput">
                                            <p v-if="!settingButtonPageBInput.img_btn_register?.id" class="btn form__btn-secondary text-nowrap">
                                                {{ settingButtonPageBInput.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPageBInput.img_btn_register?.path"
                                                    :alt="settingButtonPageBInput.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="btn form__btn-secondary text-nowrap">
                                                {{ $t('managerForm.settingPage.btnSaveForm') }}
                                            </span>
                                        </template>
                                    </div>
                                </div>
                                <div v-if="typePageShow == PAGE_TYPES._B[4]" class="d-flex justify-content-center mt-5" style="gap: 12px">
                                    <div class="btn__back" @click="handleBackForm">
                                        <template v-if="settingButtonPreview">
                                            <p v-if="!settingButtonPreview.img_btn_back?.id" class="mb-0 btn btn-back-form">
                                                {{ settingButtonPreview.label_btn_back }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreview.img_btn_back?.path"
                                                    :alt="settingButtonPreview.img_btn_back?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p class="mb-0 btn btn-back-form">戻る</p>
                                        </template>
                                    </div>

                                    <div class="btn__confirm" @click="handleSubmit(PAGE_TYPES._B[4])">
                                        <template v-if="settingButtonPreview">
                                            <p v-if="!settingButtonPreview.img_btn_confirm?.id" class="btn form__btn-secondary">
                                                {{ settingButtonPreview.label_btn_confirm }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreview.img_btn_confirm?.path"
                                                    :alt="settingButtonPreview.img_btn_confirm?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p class="btn form__btn-secondary">抽選する</p>
                                        </template>
                                    </div>
                                </div>
                                <div
                                    v-if="typePageShow == 'prize_serial' && settingButtonLottery"
                                    class="d-flex justify-content-center mt-5"
                                    style="gap: 12px"
                                >
                                    <div class="btn__next">
                                        <template>
                                            <p v-if="!settingButtonLottery.img_btn_register?.id" class="btn form__btn-secondary text-nowrap">
                                                {{ settingButtonLottery.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img text-center">
                                                <b-img
                                                    :src="settingButtonLottery.img_btn_register?.path"
                                                    :alt="settingButtonLottery.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div v-if="PAGE_TYPES._B[1] === typePageShow">
                                    <FormBSeriaLottery
                                        :inforDataLottery="dataPreview.form_pages[PAGE_TYPES._B[1]]"
                                        :settingDesign="dataPreview.setting_designs"
                                    />
                                </div>
                            </td>
                        </template>
                    </tr>
                    <tr v-if="isPageTypeI">
                        <td
                            :class="`text-${onHandleGetValueTextAlign(dataPreview.setting_designs.table_settings.answer_text_alignment.horizontal)}`"
                            :style="`padding: ${
                                dataPreview.setting_designs.table_settings?.cell_setting.margin?.value
                                    ? `${dataPreview.setting_designs.table_settings?.cell_setting.margin?.value}${dataPreview.setting_designs.table_settings?.cell_setting.margin?.unit?.value}`
                                    : '30px'
                            }`"
                        >
                            <div
                                v-if="PAGE_TYPES._I[2] == typePageShow"
                                v-html="onHandleGetInforPageTypeI(PAGE_TYPES._I[2])?.extension.content"
                            ></div>
                        </td>
                    </tr>
                    <tr v-if="FOOTER">
                        <td>
                            <div class="text-center mt-5">
                                <div v-html="FOOTER"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import CommonOption from './components/common-option.vue';
import CommonBlockText from './components/common-text.vue';
import CommonBoxMail from './components/common-box-mail.vue';
import FormBPrizeCode from './components/form-b/prize-code.vue';
import FormBSeriaLottery from './components/form-b/serial-lottery.vue';

import { configBlockForm, handleFilterBlock, matchingMessageBlocks, onHandleMapCssForm, onHandleGetValueTextAlign } from './handlers';
import { validateAllField } from '@/utils/validate';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { mapState } from 'vuex';
import { initFormPageI, configFormPageI } from './handleTypeI';
import { initFormPageBSerial, configFormPageBSerial } from './handleTypeB';
import { PAGE_TYPES, ID_PAGE_TYPE } from '../constants';

export default {
    name: 'IframComponent',
    components: {
        CommonOption,
        CommonBlockText,
        CommonBoxMail,
        FormBPrizeCode,
        FormBSeriaLottery
    },
    props: {
        dataForm: {
            type: Object,
            default: () => null
        },
        masterPage: {
            type: Array,
            default: () => []
        },
        typePage: {
            type: String,
            default: () => PAGE_TYPES._A[0]
        },
        typeHandle: {
            type: String,
            default: () => 'use'
        }
    },
    data() {
        return {
            indexCommonOption: 0,
            typePageShow: PAGE_TYPES._A[0],
            listBlockSaved: [],
            listBlockComplete: [],
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            HEADER: this.dataForm?.header ? this.dataForm?.header : '',
            FOOTER: this.dataForm?.footer ? this.dataForm?.footer : '',
            dataPreview: this.dataForm,
            settingButtonPreview: null,
            settingButtonPreviewInput: null,
            settingRequireLabel: null,
            settingConfirmLabel: null,
            settingRequireLabelTypeI: null,
            settingConfirmLabelTypeI: null,
            inforAddress: null,
            inforProvince: null,
            settingButtonPageBInput: null,
            settingButtonLottery: null,
            settingRequireLabelSerialCode: null,
            settingConfirmLabelSerialCode: null,
            initFormPageI: initFormPageI(),
            configFormPageI: configFormPageI(),
            PAGE_TYPES,
            ID_PAGE_TYPE,
            formSerialInit: initFormPageBSerial(),
            formSerialConfig: configFormPageBSerial()
        };
    },
    computed: {
        ...mapState({
            ...mapState('managerForm', ['listBlockCreated'])
        }),
        configBlockForm() {
            return handleFilterBlock(this.listBlockSaved, configBlockForm());
        },

        isPageComplete() {
            return this.typePageShow === PAGE_TYPES._A[2];
        },

        isPageTypeA() {
            return [PAGE_TYPES._A[0], PAGE_TYPES._A[1], PAGE_TYPES._A[2]].includes(this.typePageShow);
        },
        isPageTypeI() {
            return PAGE_TYPES._I.includes(this.typePageShow);
        },
        isPageTypeB() {
            return PAGE_TYPES._B.includes(this.typePageShow) || this.typePageShow === 'prize_serial';
        },

        isPageConfirm() {
            return this.typePageShow === PAGE_TYPES._A[1];
        },

        isRouterView() {
            return this.$route.name === 'ManagerFormView';
        },

        isActiveBlockAddrMailI() {
            return this.dataPreview?.page_type?.id === ID_PAGE_TYPE.I;
        },

        isPageType() {
            return (pageType) => this.dataPreview?.page_type?.id === pageType;
        }
    },
    methods: {
        onHandleGetValueTextAlign,
        handleBackForm() {
            if (this.typeHandle == 'edit') return;
            if (this.typePageShow == PAGE_TYPES._A[1]) this.typePageShow = PAGE_TYPES._A[0];
            if (this.typePageShow == PAGE_TYPES._B[4]) this.typePageShow = PAGE_TYPES._B[0];
        },

        handleSubmit(typeSubmit) {
            if (this.isRouterView) return;
            if (typeSubmit == PAGE_TYPES._A[0]) {
                this.indexCommonOption = this.indexCommonOption > 100 ? 0 : this.indexCommonOption + 1;
                let checkField = validateAllField(this.configBlockForm);
                let checkMessage = matchingMessageBlocks(this.configBlockForm, this.listBlockSaved);
                if (!checkField || !checkMessage || this.typeHandle == 'edit') return;
                this.typePageShow = PAGE_TYPES._A[1];
            } else if (typeSubmit == PAGE_TYPES._A[1]) {
                if (this.typeHandle == 'edit') return;
                this.typePageShow = PAGE_TYPES._A[2];
            } else if (typeSubmit == PAGE_TYPES._B[0]) {
                this.indexCommonOption = this.indexCommonOption > 100 ? 0 : this.indexCommonOption + 1;
                let checkField = validateAllField(this.configBlockForm);
                let checkMessage = matchingMessageBlocks(this.configBlockForm, this.listBlockSaved);
                if (!checkField || !checkMessage || this.typeHandle == 'edit') return;
                this.typePageShow = PAGE_TYPES._B[4];
            } else if (typeSubmit == PAGE_TYPES._B[4]) {
                if (this.typeHandle == 'edit') return;
                this.typePageShow = PAGE_TYPES._B[1];
            }
        },

        inforButtonPageConfirm(newDataPreview) {
            this.settingButtonPreview = newDataPreview.form_pages?.page_confirms?.setting_buttons;
            this.settingButtonPreviewInput = newDataPreview.form_pages?.page_inputs?.setting_buttons;
            this.settingRequireLabel = newDataPreview.form_pages?.page_inputs?.setting_requires;
            this.settingConfirmLabel = newDataPreview.form_pages?.page_inputs?.setting_confirms;
            this.settingButtonPageBInput = newDataPreview.form_pages?.page_input_serial_code?.setting_buttons;
            this.settingButtonLottery = newDataPreview.setting_buttons;
            this.settingRequireLabelSerialCode = newDataPreview.form_pages?.page_input_serial_code?.setting_requires;
            this.settingConfirmLabelSerialCode = newDataPreview.form_pages?.page_input_serial_code?.setting_confirms;
        },

        handleGetAddress(address) {
            this.inforAddress = address;
        },

        onHandleGetSelectProvince(provinceValue) {
            this.inforProvince = provinceValue;
        },

        onHandleGetInforPageTypeI(typeI) {
            const result = this.dataForm.setting_page.pages.flatMap((page) => page.page_child).find((child) => child.type_page_wl === typeI);
            return result;
        }
    },
    watch: {
        dataForm: {
            handler(newDataForm) {
                this.HEADER = newDataForm?.header ? newDataForm?.header : '';
                this.FOOTER = newDataForm?.footer ? newDataForm?.footer : '';
                this.dataPreview = newDataForm;
                this.inforButtonPageConfirm(newDataForm);
                onHandleMapCssForm(newDataForm.setting_designs);
                if (this.typePageShow === 'prize_serial') {
                    this.listBlockSaved = newDataForm.prize_blocks || [];
                }
            },
            immediate: true,
            deep: true
        },

        typePage: {
            handler(newTypePage) {
                this.typePageShow = newTypePage ? newTypePage : PAGE_TYPES._A[0];
                if (this.typePageShow === 'prize_serial') {
                    this.listBlockSaved = this.dataForm.prize_blocks || [];
                }
            },
            immediate: true
        },

        listBlockCreated: {
            handler(newList) {
                if (this.isPageTypeB && ![PAGE_TYPES._B[0], PAGE_TYPES._B[1], PAGE_TYPES._B[3], PAGE_TYPES._B[4]].includes(this.typePageShow)) return;
                this.listBlockSaved = newList;
                this.listBlockComplete = newList;
            },
            immediate: true
        },

        typeHandle: {
            handler(newTypeHandle) {
                if (newTypeHandle == 'edit') {
                    if (this.typePageShow !== 'prize_serial') {
                        this.listBlockSaved = this.listBlockCreated;
                    }
                } else if (newTypeHandle == 'preview') {
                    const getPageChildrenInput = this.masterPage[0].page_child;
                    const getPageChildrenComplete = this.masterPage[2].page_child;
                    const foundChildDefault = getPageChildrenInput[0];
                    this.listBlockSaved = foundChildDefault.blocks;
                    this.listBlockComplete = getPageChildrenComplete[0].blocks ?? [];
                } else {
                    this.listBlockSaved = [];
                    this.listBlockComplete = [];
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss"></style>
